import React from "react";
import { Helmet } from "react-helmet";
import { ActiveIntegrationsProvider } from "src/scenes/dashboard/active-integrations-provider";
import { Box, Grid } from "@mui/material";
import styled from "styled-components";
import IntegrationsSection from "src/scenes/setup-wizard/integrations-section";
import DetailsSection from "src/scenes/setup-wizard/details-section";
import RedirectionSection from "src/scenes/setup-wizard/redirection-section";
import { Link as RouteLink, useParams } from "react-router-dom";
import useIntegrationsApi from "src/scenes/integrations/use-integrations-api";
import useSubscriptionApi from "src/scenes/subscription/use-subscription-api";
import EnterpriseInviteSection from "src/scenes/setup-wizard/enterprise/enterprise-invite-section";
import EnterpriseIntegrationsSection from "src/scenes/setup-wizard/enterprise/enterprise-integrations-section";
import EnterpriseCreateTeams from "src/scenes/setup-wizard/enterprise/enterprise-create-teams";
import { TeamProvider } from "src/scenes/teams/team/team-provider";
import { TeamsProvider } from "src/scenes/teams/teams-provider";
import { MembersProvider } from "src/scenes/teams/members-provider";
import { ActiveIntegrationsProviderTeams } from "src/scenes/teams/dashboard/active-integrations-provider-teams";

const StepContainer = styled(Box)`
    border-radius: 14px;
    border: 1px dashed #6c6c6c;
    padding: 12px;
    min-height: 167px;
`;

const Link = styled(RouteLink)`
    font-size: 12px;
    font-weight: 400;
    margin: 0;
    color: ${({ theme }) => theme.palette.background.inactiveIcons};
    text-decoration: none;
    cursor: pointer;
    white-space: nowrap;
    padding-right: 20px;
    &:hover {
        text-decoration: underline;
        color: ${({ theme }) => theme.palette.primary.main};
    }
`;

const SetupWizard = () => {
    const integrationsApi = useIntegrationsApi();
    const [subscription, setSubscription] = React.useState();
    const [isFiltered, setIsFiltered] = React.useState(false);
    const subscriptionApi = useSubscriptionApi();
    const { teamId } = useParams();

    React.useEffect(() => {
        if (subscriptionApi.data) {
            const team = subscriptionApi.data.find((sub) => sub.subscription.type === "team");
            const enterprise = subscriptionApi.data.find(
                (sub) => sub.subscription.type === "enterprise"
            );
            const personal = subscriptionApi.data.find(
                (sub) => sub.subscription.type === "personal"
            );
            if (team) {
                setSubscription(team);
            } else if (enterprise) {
                setSubscription(enterprise);
            } else if (personal) {
                setSubscription(personal);
            } else {
                setSubscription({ subscription: { type: "free" } });
            }
        }
    }, [subscriptionApi.data]);

    React.useEffect(() => {
        if (!localStorage.getItem("wizard") || localStorage.getItem("wizard", false))
            localStorage.setItem("wizard", true);
    }, []);

    const isUserPlanAdmin = subscription && subscription.subscription.isAdmin;

    if (!subscription) return null;
    return (
        <ActiveIntegrationsProvider>
            <Helmet>
                <title>Adadot - Account Setup</title>
            </Helmet>
            {subscription &&
                subscription.subscription &&
                (subscription.subscription.type === "enterprise" ||
                    subscription.subscription.type === "team") && (
                    <Grid id="personal" container spacing={2}>
                        <TeamsProvider>
                            <MembersProvider>
                                <ActiveIntegrationsProviderTeams teamId={teamId}>
                                    <TeamProvider>
                                        <Grid item md={12}>
                                            <StepContainer>
                                                <EnterpriseIntegrationsSection
                                                    userIntegrations={integrationsApi}
                                                />
                                            </StepContainer>
                                        </Grid>
                                        <Grid item md={12}>
                                            <StepContainer>
                                                {isUserPlanAdmin ? (
                                                    <EnterpriseInviteSection
                                                        subscription={
                                                            subscription &&
                                                            subscription.subscription
                                                        }
                                                        integrationsApi={integrationsApi}
                                                        isFiltered={isFiltered}
                                                        setIsFiltered={setIsFiltered}
                                                    />
                                                ) : (
                                                    <DetailsSection />
                                                )}
                                            </StepContainer>
                                        </Grid>
                                        <Grid item md={12}>
                                            <StepContainer>
                                                <EnterpriseCreateTeams />
                                            </StepContainer>
                                        </Grid>
                                    </TeamProvider>
                                </ActiveIntegrationsProviderTeams>
                            </MembersProvider>
                        </TeamsProvider>

                        <Grid
                            item
                            md={12}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-end",
                            }}
                        >
                            <Link
                                onClick={() => {
                                    localStorage.removeItem("wizard");
                                }}
                                to="/dashboard"
                            >
                                Skip setup and view demo{" "}
                            </Link>
                        </Grid>
                    </Grid>
                )}
            {subscription &&
                subscription.subscription &&
                subscription.subscription.type === "free" && (
                    <Grid id="personal" container spacing={2}>
                        <Grid item md={7}>
                            <StepContainer>
                                <IntegrationsSection integrationsApi={integrationsApi} />
                            </StepContainer>
                        </Grid>
                        <Grid item md={5}>
                            <StepContainer>
                                <DetailsSection />
                            </StepContainer>
                        </Grid>
                        <Grid item md={12}>
                            <StepContainer>
                                <RedirectionSection integrationsApi={integrationsApi} />
                            </StepContainer>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-end",
                                marginBottom: "24px",
                            }}
                        >
                            <Link
                                onClick={() => {
                                    localStorage.removeItem("wizard");
                                }}
                                to="/dashboard"
                            >
                                Skip setup and view demo{" "}
                            </Link>
                        </Grid>
                    </Grid>
                )}
        </ActiveIntegrationsProvider>
    );
};

export default SetupWizard;
